import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { capitalGoodsAndServicesColumns, capitalGoodsAndServicesGrandTotalFields, capitalGoodsAndServicesTotalColumns, chemicalsAndAdditivesColumns, chemicalsAndAdditivesGrandTotalFields, chemicalsAndAdditivesTotalColumns, otherColumns, otherGrandTotalFields, otherTotalColumns, packagingColumns, packagingGrandTotalFields, packagingTotalColumns, waterColumns, waterGrandTotalFields, waterTotalColumns, wineAndGrapesColumns, wineAndGrapesGrandTotalFields, wineAndGrapesTotalColumns, woodenProductsColumns, woodenProductsGrandTotalFields, woodenProductsTotalColumns } from '../constants/category-four-columns';
import { getWaterData, getWaterDataTotals, postWaterData } from '../../../../../actions/carbonfootprint-rework/04-indirect-ghg-emissions-from-products-used-by-an-organisation/01-water-actions';
import { getChemicalsAndAdditivesData, getChemicalsAndAdditivesDataTotals, postChemicalsAndAdditivesData } from '../../../../../actions/carbonfootprint-rework/04-indirect-ghg-emissions-from-products-used-by-an-organisation/02-purchased-chemicals-and-additives';
import { getWoodenProductsData, getWoodenProductsDataTotals, postWoodenProductsData } from '../../../../../actions/carbonfootprint-rework/04-indirect-ghg-emissions-from-products-used-by-an-organisation/03-wooden-products';
import { getPackagingMaterialsData, getPackagingMaterialsDataTotals, postPackagingMaterialsData } from '../../../../../actions/carbonfootprint-rework/04-indirect-ghg-emissions-from-products-used-by-an-organisation/04-packaging-materials';
import { getWineAndGrapesData, getWineAndGrapesDataTotals, postWineAndGrapesData } from '../../../../../actions/carbonfootprint-rework/04-indirect-ghg-emissions-from-products-used-by-an-organisation/05-wine-and-grapes';
import { getOtherData, getOtherDataTotals, postOtherData } from '../../../../../actions/carbonfootprint-rework/04-indirect-ghg-emissions-from-products-used-by-an-organisation/06-other';
import { getCapitalGoodsAndServicesData, getCapitalGoodsAndServicesDataTotals, postCapitalGoodsAndServicesData } from '../../../../../actions/carbonfootprint-rework/04-indirect-ghg-emissions-from-products-used-by-an-organisation/07-capital-goods-and-services';
import { getSuppliers } from '../../../../../actions/carbonfootprint-rework/04-indirect-ghg-emissions-from-products-used-by-an-organisation/00-suppliers';
import useTsPaginator from 'ts-paginator';
import { MONTHMAPPER } from '../constants/months';
import { uploadCsvDocument } from '../../../../../actions/carbonfootprint-rework/00-base/00-base-actions';


export function useCategoryFourDataStore(selectedCategory, year, company, group, facility) {
    const dispatch = useDispatch();
    const [month, setMonth] = useState(0);

    // --- declare useSelector variables ---
    const waterData = useSelector((state) => state.indirectGhgEmissionsFromProductsForWaterReducer.waterData?.data)
    const waterTableRecords = useSelector((state) => state.indirectGhgEmissionsFromProductsForWaterReducer.waterData?.pagination?.total_records);
    const waterDataTotals = useSelector((state) => state.indirectGhgEmissionsFromProductsForWaterReducer.waterDataTotals?.data)
    const chemicalsAndAdditivesData = useSelector((state) => state.indirectGhgEmissionsFromProductsForChemicalsAndAdditivesReducer.chemicalsAndAdditivesData?.data)
    const chemicalsAndAdditivesTableRecords = useSelector((state) => state.indirectGhgEmissionsFromProductsForChemicalsAndAdditivesReducer.chemicalsAndAdditivesData?.pagination?.total_records);
    const chemicalsAndAdditivesDataTotals = useSelector((state) => state.indirectGhgEmissionsFromProductsForChemicalsAndAdditivesReducer.chemicalsAndAdditivesDataTotals?.data)
    const woodenProductsData = useSelector((state) => state.indirectGhgEmissionsFromProductsForWoodenProductsReducer.woodenProductsData?.data)
    const woodenProductsTableRecords = useSelector((state) => state.indirectGhgEmissionsFromProductsForWoodenProductsReducer.woodenProductsData?.pagination?.total_records);
    const woodenProductsDataTotals = useSelector((state) => state.indirectGhgEmissionsFromProductsForWoodenProductsReducer.woodenProductsDataTotals?.data)
    const packagingData = useSelector((state) => state.indirectGhgEmissionsFromProductsForPackagingMaterialsReducer.packagingMaterialsData?.data)
    const packagingTableRecords = useSelector((state) => state.indirectGhgEmissionsFromProductsForPackagingMaterialsReducer.packagingMaterialsData?.pagination?.total_records);
    const packagingDataTotals = useSelector((state) => state.indirectGhgEmissionsFromProductsForPackagingMaterialsReducer.packagingMaterialsDataTotals?.data)
    const wineAndGrapesData = useSelector((state) => state.indirectGhgEmissionsFromProductsForWineAndGrapesReducer.wineAndGrapesData?.data)
    const wineAndGrapesTableRecords = useSelector((state) => state.indirectGhgEmissionsFromProductsForWineAndGrapesReducer.wineAndGrapesData?.pagination?.total_records);
    const wineAndGrapesDataTotals = useSelector((state) => state.indirectGhgEmissionsFromProductsForWineAndGrapesReducer.wineAndGrapesDataTotals?.data)
    const otherData = useSelector((state) => state.indirectGhgEmissionsFromProductsForOtherReducer.otherData?.data)
    const otherTableRecords = useSelector((state) => state.indirectGhgEmissionsFromProductsForOtherReducer.otherData?.pagination?.total_records);
    const otherDataTotals = useSelector((state) => state.indirectGhgEmissionsFromProductsForOtherReducer.otherDataTotals?.data)
    const capitalGoodsAndServicesData = useSelector((state) => state.indirectGhgEmissionsFromProductsForCapitalGoodsAndServicesReducer.capitalGoodsAndServicesData?.data)
    const capitalGoodsAndServicesTableRecords = useSelector((state) => state.indirectGhgEmissionsFromProductsForCapitalGoodsAndServicesReducer.capitalGoodsAndServicesData?.pagination?.total_records);
    const capitalGoodsAndServicesDataTotals = useSelector((state) => state.indirectGhgEmissionsFromProductsForCapitalGoodsAndServicesReducer.capitalGoodsAndServicesDataTotals?.data)

    // --- constant api endpoints, backend quirk ---
    const { suppliers } = useSelector(state => state.indirectGhgEmissionsFromProductsSuppliers)

    // --- variable manipulation, to make hook call cleaner ---

    const selectedCategoryDataMap = {
        'Water': {
            data: waterData,
            totals: waterDataTotals,
            getDataAction: getWaterData,
            getTotalsAction: getWaterDataTotals,
            postDataAction: postWaterData,
            categoryKey: 'water',
            columns: waterColumns(suppliers?.data),
            totalColumns: waterTotalColumns,
            grandTotalFields: waterGrandTotalFields,
            tableRecordCount: waterTableRecords,
        },
        'Chemicals and Additives': {
            data: chemicalsAndAdditivesData,
            totals: chemicalsAndAdditivesDataTotals,
            getDataAction: getChemicalsAndAdditivesData,
            getTotalsAction: getChemicalsAndAdditivesDataTotals,
            postDataAction: postChemicalsAndAdditivesData,
            categoryKey: 'chemicals-and-additives',
            columns: chemicalsAndAdditivesColumns(suppliers?.data),
            totalColumns: chemicalsAndAdditivesTotalColumns,
            grandTotalFields: chemicalsAndAdditivesGrandTotalFields,
            tableRecordCount: chemicalsAndAdditivesTableRecords,
        },
        'Wooden Products': {
            data: woodenProductsData,
            totals: woodenProductsDataTotals,
            getDataAction: getWoodenProductsData,
            getTotalsAction: getWoodenProductsDataTotals,
            postDataAction: postWoodenProductsData,
            categoryKey: 'wooden-products',
            columns: woodenProductsColumns(suppliers?.data),
            totalColumns: woodenProductsTotalColumns,
            grandTotalFields: woodenProductsGrandTotalFields,
            tableRecordCount: woodenProductsTableRecords,
        },
        'Packaging': {
            data: packagingData,
            totals: packagingDataTotals,
            getDataAction: getPackagingMaterialsData,
            getTotalsAction: getPackagingMaterialsDataTotals,
            postDataAction: postPackagingMaterialsData,
            categoryKey: 'packaging',
            columns: packagingColumns(suppliers?.data),
            totalColumns: packagingTotalColumns,
            grandTotalFields: packagingGrandTotalFields,
            tableRecordCount: packagingTableRecords,
        },
        'Wine and Grapes': {
            data: wineAndGrapesData,
            totals: wineAndGrapesDataTotals,
            getDataAction: getWineAndGrapesData,
            getTotalsAction: getWineAndGrapesDataTotals,
            postDataAction: postWineAndGrapesData,
            categoryKey: 'wine-and-grapes',
            columns: wineAndGrapesColumns(suppliers?.data),
            totalColumns: wineAndGrapesTotalColumns,
            grandTotalFields: wineAndGrapesGrandTotalFields,
            tableRecordCount: wineAndGrapesTableRecords,
        },
        'Other': {
            data: otherData,
            totals: otherDataTotals,
            getDataAction: getOtherData,
            getTotalsAction: getOtherDataTotals,
            postDataAction: postOtherData,
            categoryKey: 'other',
            columns: otherColumns(suppliers?.data),
            totalColumns: otherTotalColumns,
            grandTotalFields: otherGrandTotalFields,
            tableRecordCount: otherTableRecords,
        },
        'Capital Goods and Services': {
            data: capitalGoodsAndServicesData,
            totals: capitalGoodsAndServicesDataTotals,
            getDataAction: getCapitalGoodsAndServicesData,
            getTotalsAction: getCapitalGoodsAndServicesDataTotals,
            postDataAction: postCapitalGoodsAndServicesData,
            categoryKey: 'capital-goods-and-services',
            columns: capitalGoodsAndServicesColumns(suppliers?.data),
            totalColumns: capitalGoodsAndServicesTotalColumns,
            grandTotalFields: capitalGoodsAndServicesGrandTotalFields,
            tableRecordCount: capitalGoodsAndServicesTableRecords,
        }
    }

    const {
        data,
        totals,
        getDataAction,
        getTotalsAction,
        postDataAction,
        categoryKey,
        columns,
        totalColumns,
        grandTotalFields,
        tableRecordCount
    } = selectedCategoryDataMap[selectedCategory] ||
        {
            data: null,
            totals: null,
            getDataAction: null,
            getTotalsAction: null,
            postDataAction: null,
            categoryKey: null,
            columns: [],
            totalColumns: [],
            grandTotalFields: [],
            tableRecordCount: 0
        };

    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 0);

    useEffect(() => {
        // if (currentProjectId !== projectId) {
        _handleChangePage(0); // Reset to the first page
        _handleChangeRowsPerPage(10)
        _handleChangeTotalRecordCount(+tableRecordCount); // Reset to the first page
        // }
    }, [tableRecordCount]);

    useEffect(() => {
        const monthForBackend = MONTHMAPPER[month];
        if (selectedCategory === 'Water') {
            dispatch(getWaterData(year, facility, rowsPerPage, currentPage, monthForBackend))
            dispatch(getSuppliers(group))
        }
        if (selectedCategory === 'Chemicals and Additives') {
            dispatch(getChemicalsAndAdditivesData(year, facility, rowsPerPage, currentPage, monthForBackend))
            dispatch(getSuppliers(group))
        }
        if (selectedCategory === 'Wooden Products') {
            dispatch(getWoodenProductsData(year, facility, rowsPerPage, currentPage, monthForBackend))
            dispatch(getSuppliers(group))
        }
        if (selectedCategory === 'Packaging') {
            dispatch(getPackagingMaterialsData(year, facility, rowsPerPage, currentPage, monthForBackend))
            dispatch(getSuppliers(group))
        }
        if (selectedCategory === 'Wine and Grapes') {
            dispatch(getWineAndGrapesData(year, facility, rowsPerPage, currentPage, monthForBackend))
            dispatch(getSuppliers(group))
        }
        if (selectedCategory === 'Other') {
            dispatch(getOtherData(year, facility, rowsPerPage, currentPage, monthForBackend))
            dispatch(getSuppliers(group))
        }
        if (selectedCategory === 'Capital Goods and Services') {
            dispatch(getCapitalGoodsAndServicesData(year, facility, rowsPerPage, currentPage, monthForBackend))
            dispatch(getSuppliers(group))
        }

    }, [dispatch, selectedCategory, year, facility, group, company, rowsPerPage, currentPage]
    )

    return {
        month,
        setMonth,
        data,
        totals,
        getDataAction,
        getTotalsAction,
        postDataAction,
        uploadCsvDocument,
        categoryKey,
        columns,
        totalColumns,
        grandTotalFields,
        year,
        facility,
        group,
        company,
        // pagination
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    }
}